import { createSelector } from 'reselect'
import { selectBase } from './selectBase'
import { pricingIdToComponents } from '../util'
import { selectFuturePhase } from './selectFuturePhase'

export const selectPendingFuturePhaseDetailed = createSelector(
  selectBase,
  selectFuturePhase,
  (base, futurePhase) => {
    const pendingDowngrades = { inbox: null, kb: null }
    if (!futurePhase) return pendingDowngrades

    const phaseDowngrades = futurePhase.items.reduce((downgrades, phase) => {
      const { product: phaseProduct, planId, cycle } = pricingIdToComponents(
        phase.plan
      )

      const isPlanChange =
        base.billing_cycle !== cycle || base[phaseProduct].plan !== planId
      // eslint-disable-next-line no-param-reassign
      downgrades[phaseProduct] = {
        planId,
        cycle,
        phaseProduct,
        isPlanChange,
      }
      return downgrades
    }, {})

    return {
      ...pendingDowngrades,
      ...phaseDowngrades,
    }
  }
)
